import React from 'react';
import styles from './PreviewSwitcher.module.scss';
import cn from 'classnames';
import { Icon } from 'antd';
import PropTypes from 'prop-types';

const PreviewSwitcher = ({ filesOrder = 0, files = [], onClick }) => {
  const isFirstPage = filesOrder === 0;
  const isLastPage = filesOrder === files.length - 1;

  return (
    <div className={styles.root}>
      <div
        className={cn(styles.switch, {
          [styles.disbled]: isFirstPage,
        })}
        onClick={() => (isFirstPage ? undefined : onClick(filesOrder - 1))}
      >
        <Icon
          style={{ color: isFirstPage ? '#A8A8A8' : '#0995ED' }}
          type="left"
        />
      </div>
      <div
        className={cn(styles.switch, {
          [styles.disbled]: isLastPage,
        })}
        onClick={() => (isLastPage ? undefined : onClick(filesOrder + 1))}
      >
        <Icon
          style={{ color: isLastPage ? '#A8A8A8' : '#0995ED' }}
          type="right"
        />
      </div>
    </div>
  );
};

PreviewSwitcher.propTypes = {
  filesOrder: PropTypes.number.isRequired,
  files: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PreviewSwitcher;
